import Vue from 'vue';
import store from "@/store";

import Cookie from '@/utils/cookie.js' // 验权
/**权限指令**/
const has = Vue.directive('has', {
  bind: function (el, binding, vnode) {
    let val = Cookie.getCookie("isDistribution")
    if (val == "1") {  //val为1的时候是业务系统
      // 获取按钮权限
      let btnPermissions = store.state.user.permissions;
      if (btnPermissions.findIndex(c => c === binding.value) == -1) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
        else {
          el.style.display = "none";
        }
      }
    }
  }
});
export default has;